import { createStoreWithTools } from ".";

export const useToastStore = createStoreWithTools((set) => ({
  toasts: [],
  count: 0,
  addToast: (toast) => addToast(set, toast),
  removeToast: (id) => removeToast(set, id),
}));

export const useGlobalToastStore = createStoreWithTools((set) => ({
  toasts: [],
  count: 0,
  addToast: (toast) => addToast(set, toast),
  removeToast: (id) => removeToast(set, id),
}));

const addToast = (set, toast) => {
  set((state) => {
    if (toast.id && state.toasts.find((exToast) => exToast.id === toast.id)) {
      return {
        toasts: [...state.toasts],
      };
    } else {
      return {
        toasts: [...state.toasts, { id: `toast-${state.count}`, ...toast }],
        count: state.count + 1,
      };
    }
  });
};

const removeToast = (set, id) => {
  set((state) => ({
    toasts: state.toasts.filter((toast) => toast.id !== id),
  }));
};
